import { app } from '../../../../app';

app.factory('SlackVerificationDataService', SlackVerificationDataService);

/** @ngInject */
function SlackVerificationDataService($resource) {
    return $resource('app/rest/slackverificationdata', {}, {});
}



// WEBPACK FOOTER //
// ./src/portal/states/public/verification/slack/slack-verification.service.js